import { render, staticRenderFns } from "./MiraDotPlot.vue?vue&type=template&id=90ceaa10&scoped=true&"
import script from "./MiraDotPlot.vue?vue&type=script&lang=ts&"
export * from "./MiraDotPlot.vue?vue&type=script&lang=ts&"
import style0 from "./MiraDotPlot.vue?vue&type=style&index=0&id=90ceaa10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ceaa10",
  null
  
)

export default component.exports